<template>
	<!-- component for the payment revamp nexon game cards and epin redeemption -->
	<div class="payment-wrapper wrapper">
		<div class="modal" :class="{ hide: !pageLoading }">
			<div id="main-spinner" class="page-spinner-wrapper main-spinner">
				<span class="spinner-circle"></span>
			</div>
		</div>

		<div v-if="!pageLoading" class="murk">
			<balanceInfo :title="$t('checkout.redeem-nx')" show-switch-account></balanceInfo>

			<div class="order-detail-wrapper">
				<iframe ref="paymentFrame" class="iframe-container payment-container" :src="iframeURL"> </iframe>

				<div class="submit-holder">
					<buttonType
						class="submit-button"
						:loading="buttonLoading"
						:btn-primary="true"
						:label="$t('back')"
						:button-click="backToPrevious"
					>
					</buttonType>
				</div>

				<div v-if="isEUCountry" class="eu-law-message">
					{{ $t('checkout.eu-law-message', { buttonName: $t('checkout.redeem-balance') }) }}
				</div>

				<recaptcha-attribution></recaptcha-attribution>
			</div>
		</div>
	</div>
</template>

<script>
import buttonType from '@arena/toolkit/src/components/common/button';
import balanceInfo from '@/components/common/balance-info';
import recaptchaAttribution from '@/components/common/recaptcha-attribution';
import config from '@/config/environment-config';

export default {
	name: 'RedeemBalance',
	components: {
		balanceInfo,
		buttonType,
		recaptchaAttribution,
	},
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('checkout.title')}`,
		};
	},
	data() {
		return {
			showLoadingContainer: true,
			buttonLoading: false,
			pageLoading: false,
		};
	},
	computed: {
		isEUCountry() {
			return this.$store.state.isEUCountry;
		},
		authorizedUrl() {
			return this.$store.state.authorizedUrl;
		},
		iframeURL() {
			return this.authorizedUrl ? this.replaceUrlLocale(this.authorizedUrl, 2) : null;
		},
		getGoBackURL() {
			return this.$store.state.redirectUrl;
		},
	},
	created() {
		if (!this.authorizedUrl) {
			this.pageLoading = true;
			this.$store.dispatch('fetchVerifyEpinNexonCardsToken').then(() => {
				this.pageLoading = false;
			});
		}
		window.addEventListener('message', this.receivedIframeMessage);
	},
	beforeDestroy() {
		window.removeEventListener('message', this.receivedIframeMessage);
	},
	methods: {
		backToPrevious() {
			this.buttonLoading = true;
			if (this.getGoBackURL) {
				this.goto(this.getGoBackURL);
			} else if (this.$store.state.appType === 'game') {
				window.close();
			} else {
				window.location.href = `${config[process.env.VUE_APP_ENV][environment.region].wallet}/${
					this.$i18n.locale
				}/add-balance`;
			}
		},
		receivedIframeMessage(message) {
			if (message && message.data) {
				if (message.data.eventType === 'tracking') {
					dataLayer.push({
						event: 'Add Balance Code Redemption Validate',
						'Redemption Type': message.data.info.methodName,
						'NX Amount': message.data.info.nxAmount,
					});
				} else if (message.data.eventType === 'error') {
					dataLayer.push({
						event: 'Add Balance Error',
						'Add Balance Error Message': message.data.error,
					});
				}
			}
		},
	},
};
</script>

<style lang="less" scoped>
.payment-wrapper {
	.submit-button {
		max-width: 320px;
		margin: 5px auto 0;
	}
	h2 {
		margin-bottom: 80px;
	}
	.order-detail-wrapper {
		font-size: 16px;
		max-width: 580px;
		min-width: 320px;
		height: 385px;
		margin: 50px auto 50px;
	}
	.iframe-container {
		width: 100%;
		height: 100%;
		background-color: transparent;
		border: none;
	}
	.eu-law-message {
		max-width: 320px;
		margin-top: 20px;
		margin-bottom: -10px;
		margin-left: auto;
		margin-right: auto;
		font-size: 12px;
	}

	@media (max-width: 650px) {
		.order-detail-wrapper {
			margin-top: 10px;
		}
	}
}
</style>
